import type {
  ChangeEvent,
  ClipboardEvent,
  KeyboardEvent,
  RefObject,
} from "react";
import { Typewriter } from "@shared/components/Typewriter";
import {
  AutosizeReference,
  Textarea,
  TextareaMirror,
  TextareaWrapper,
} from "./styles";

type Props = {
  mirrorRef: RefObject<HTMLDivElement>;
  referenceRef: RefObject<HTMLDivElement>;
  textareaRef: RefObject<HTMLTextAreaElement>;
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  onPaste: (e: ClipboardEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  disabled: boolean;
  isListening: boolean;
  isMultiline: boolean;
  showTypewriter: boolean;
  typewriterText?: string;
  onFinishTyping: () => void;
};

export const MessageBarTextarea = ({
  mirrorRef,
  referenceRef,
  textareaRef,
  value,
  onChange,
  onKeyDown,
  onPaste,
  placeholder,
  disabled,
  isListening,
  isMultiline,
  showTypewriter,
  typewriterText,
  onFinishTyping,
}: Props) => (
  <>
    <AutosizeReference ref={referenceRef} aria-hidden>
      {" "}
    </AutosizeReference>
    <TextareaWrapper
      $isListening={isListening}
      $isMultiline={isMultiline}
      style={showTypewriter ? { display: "none" } : undefined}
    >
      <TextareaMirror ref={mirrorRef} aria-hidden>
        {value}
        {" "}
      </TextareaMirror>
      <Textarea
        name="message"
        placeholder={placeholder}
        ref={textareaRef}
        disabled={disabled}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        onChange={onChange}
        value={value}
        rows={1}
        autoFocus
        $isListening={isListening}
        $isMultiline={isMultiline}
      />
    </TextareaWrapper>
    {typewriterText && (
      <Typewriter
        text={typewriterText}
        sx={{ display: "flex", alignItems: "center", minHeight: "50px" }}
        startDelay={4000}
        speed={110}
        finishDelay={1000}
        onFinishTyping={onFinishTyping}
      />
    )}
  </>
);
